module.exports = __webpack_public_path__ + "img/logo.fc43587b.svg";